const PIXEL_ID = '2424293584706585'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized) return
  initialized = true

  // Standard Meta Pixel base code
  ;(function (f: any, b: any, e: any, v: any) {
    if (f.fbq) return
    const n: any = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    const t = b.createElement(e)
    t.async = !0
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')

  // Add noscript img fallback for Pixel Helper detection
  const noscriptImg = document.createElement('img')
  noscriptImg.height = 1
  noscriptImg.width = 1
  noscriptImg.style.display = 'none'
  noscriptImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(noscriptImg)
}

export function trackInitiateCheckout() {
  if (window.fbq) {
    window.fbq('track', 'InitiateCheckout')
  }
}
